/**
 * Formats a numeric count into specific string representations based on defined ranges.
 *
 * Rules:
 * - Returns the exact count as a string for values between 0 and 5, inclusive.
 * - For values between 6 and 50, rounds down to the nearest multiple of 5 and appends a '+' sign.
 * - For values over 50, rounds down to the nearest multiple of 50 and appends a '+' sign.
 *
 * @param {number} count - The numerical count to format.
 * @returns {string} The formatted count following the specified rules.
 */
const formatCount = (count = 0) => {
  const floor = Math.floor(count)
  if (floor >= 0 && floor <= 5) {
    return floor.toString()
  } else if (floor > 5 && floor <= 50) {
    const remainder = floor % 5
    const nearestMultipleOfFive = floor - remainder
    return nearestMultipleOfFive.toString() + '+'
  } else if (floor > 50) {
    const remainder = floor % 50
    const nearestMultipleOfFifty = floor - remainder
    return nearestMultipleOfFifty.toString() + '+'
  }

  return '0'
}

export default formatCount
